export enum PlacementUpdateEvent {
    DELETE = 'removingArticles',
    PLACE = 'placingArticles',
    COPY = 'copyingArticles'
}
